/*
 * @Description: 
 * @Author: 
 * @Date: 2022-06-24 17:06:51
 * @LastEditTime: 2022-08-16 11:18:30
 * @LastEditors: dongqianqian
 * @Usage: 
 */
import to from "await-to-js";
import { Api_Company, Api_login } from "@/api/api";
import { BASE_URL } from '@/util/constant';
import { getStore } from '@/util/store';

export const actions = {
  async getCompanyInfo({ commit, state }) {
    const companyId = getStore({ name: 'companyId' })
    const [err, { data }] = await to(
      Api_Company.info(state.userInfo.companyId || companyId)
    );
    if (err) return;
    if (data.statusCode !== 200) return;
    // 此处让后端删除了密码，解决公司管理员点击“编辑”按钮，管理员账号的密码被重置
    commit("setCompanyInfo", data.data);
  },
  async getUserInfo({ commit, state }) {
    const userId = getStore({ name: 'userId' })
    const [err, { data }] = await to(
      Api_login.userInfo(state.userInfo.id || userId)
    );
    if (err) return;
    if (data.statusCode !== 200) return;
    data.data.platFormLogo = BASE_URL + data.data.platFormLogo
    commit("setUserInfo", data.data);
  },
};
